/**
 * @file        src/pages/hotel/AmendmentMarkup.jsx
 * @description Hotel Amendment Markup (CRUD) over hotel_amendment_markups (admin
 *              migration 078): our own flat markup PER ROOM PER NIGHT on a hotel
 *              cancellation. CorporateAmendmentMarkup renders it fixed to
 *              audience=b2b (§9d).
 * @author      Kinetika Labs
 * @created     2026-10-10
 * @changelog
 *   - 2026-10-10 Claude — Initial.
 */
import SimpleLookupPage from '../package/SimpleLookupPage';
import { domIntField } from '../../lib/domInt';

const ROLE = [
  { value: 'b2c', label: 'B2C (retail)' },
  { value: 'b2b', label: 'B2B / Corporate' },
];

export default function HotelAmendmentMarkup({
  title = 'Amendment Markup',
  subtitle = 'B2C Hotel · our markup on cancellations',
  audience = 'b2c',
} = {}) {
  return (
    <SimpleLookupPage
      title={title}
      subtitle={subtitle}
      endpoint="/hotel-amendment-markups"
      queryRoot={`hotel-amendment-markups-${audience}`}
      addLabel="Add Amendment Markup"
      entityLabel="Amendment markup"
      listParams={{ audience }}
      notice={<span>A <b>flat amount per room, per night</b> (₹300 on 2 rooms for 3 nights is ₹1,800), added to the hotel&apos;s cancellation charge and taken off the refund, and <b>never shown to the customer as a separate line</b>. A refund never goes below ₹0. Of the active rules for the booking&apos;s brand and buyer type, the <b>most specific</b> applies (a Domestic- or International-only rule beats one for both); between equally specific rules the <b>most recently added</b> wins.</span>}
      fields={[
        { key: 'brand', label: 'Brand', type: 'brand', required: true },
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'markup_value', label: 'Markup per Room per Night (₹)', type: 'number', required: true, min: 0, step: '0.01' },
        // Domestic / International stays (blank = both).
        domIntField(),
        { key: 'applicable_role', label: 'Applies To', type: 'select', options: ROLE, form: false, default: audience === 'b2b' ? 'b2b' : 'b2c' },
      ]}
    />
  );
}
